import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(8)};
  text-align: center;
  width: 100%;
  height: 100%;
  flex: 1;
`;

export const IconContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  color: ${({ theme }) => theme.palette.grey[600]};

  svg {
    width: 2.4rem;
    height: 2.4rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  max-width: 20rem;
`;

export const Description = styled(Typography).attrs({ variant: 'overline' })`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Interactions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
